@if (viewModel$ | async; as vm) {

  @if (vm.display && vm.pollutant) {
    <section>

      <div class="air-quality is-flex">
        <div class="is-flex is-column gap-4 has-spacing-bottom-s">
          <app-text class="text-14 is-family-semiBold">{{ 'station-app.__WS_INFO_5_LABEL3' | AsyncLang | async }}</app-text>
        </div>

        <div class="is-flex is-space-between gap-12 quality" [style.color]="POLLUTANT_MAP[vm.pollutant.category].color">
          <app-text class="text-12 is-family-semiBold text-grey-70">{{ vm.pollutant.aqi }}&nbsp;(PM 2.5)</app-text>

          <app-text class="aqi-label is-family-semiBold text-12"
            [style.backgroundColor]="POLLUTANT_MAP[vm.pollutant.category].backgroundColor">
            {{ POLLUTANT_MAP[vm.pollutant.category].label | AsyncLang | async }}
          </app-text>

        </div>
      </div>

    </section>
  }
}